import {fetch} from '@shopify/cli-kit/node/http';
import {Logger, outputInfo} from '@shopify/cli-kit/node/output';

import {DeploymentConfig, DeploymentHooks, VerificationError} from './types.js';

interface VerificationOptions {
  config: DeploymentConfig;
  hooks?: DeploymentHooks;
  logger: Logger;
  url: string;
}

export async function verifyDeployment(
  options: VerificationOptions,
): Promise<void> {
  const {config, url, logger, hooks} = options;
  hooks?.onVerificationStart?.();
  outputInfo('Verifying worker deployment is routable...', logger);

  let attempts = 0;
  let delay = 0;
  let calledVerificationError = false;
  const startTime = Date.now();

  const handleInterval = async () => {
    if (attempts < 10) {
      delay = 500;
    } else if (attempts % 5 === 0) {
      delay += 5000;
    }
    const elapsedTime = (Date.now() - startTime) / 1000;
    if (elapsedTime + delay / 1000 > config.verificationMaxDuration) {
      const error = new VerificationError(
        'Unable to verify that the worker is accessible.',
      );
      if (!calledVerificationError) {
        calledVerificationError = true;
        hooks?.onVerificationError?.(error);
      }
      throw error;
    }
    attempts++;
    await new Promise((resolve) => setTimeout(resolve, delay));
    await check();
  };

  const check = async () => {
    try {
      const response = await fetch(`${url}/.oxygen/deployment`, {
        method: 'HEAD',
      });
      if (response.status === 200) {
        outputInfo('Deployment verification check passed', logger);
        hooks?.onVerificationComplete?.();
        return Promise.resolve();
      }
      await handleInterval();
    } catch {
      await handleInterval();
    }
  };

  await check();
}
